import { apiSlice } from '../../app/services/apiSlice';

const PRODUCT_URL = 'backoffice/products';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllProducts: builder.query({
      query: (params) => ({
        url: `${PRODUCT_URL}`,
        params,
      }),
    }),
     getProductsAgainstJobboard: builder.query({
      query: (params) => ({
        url: `backoffice/multi-poster/company/job-board/products/${params?.compId}/OCCY_${params?.accessKey}`,
      }),
    }),
     getAllJobboardsAgainstCompany: builder.query({
      query: (params) => ({
        url: `backoffice/multi-poster/company/job-boards/${params?.compId}`,
      }),
    }),
    addNewProduct: builder.mutation({
      query: (data) => ({
        url: `${PRODUCT_URL}`,
        method: 'POST',
        body: {
          ...data,
        },
      }),
    }),
  removeMultiposterJobboard: builder.mutation({
      query: (data) => ({
        url: `backoffice/multi-poster/company/job-boards/${data?.compId}/${data?.id}`,
        method: 'DELETE',
      }),
    }),
    removeProduct: builder.mutation({
      query: (data) => ({
        url: `${PRODUCT_URL}/${data}`,
        method: 'DELETE',
      }),
    }),
    getSingleProductById: builder.mutation({
      query: (id) => ({
        url: `${PRODUCT_URL}/${id}`,
        method: 'GET',
      }),
    }),
     getMultiposterJobBoards: builder.mutation({
      query: (params) => ({
        url: `backoffice/multi-poster/job-boards`,
        params: { ...params, sort: 'name', sortDir: 'ASC' }
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.jobBoards?.map((option) => (
          {
            label: option?.title,
            value: option?.id,
            accessKey: option?.accessKey
          }));
        return responseData || {};
      },
    }),
    getJobBoards: builder.mutation({
      query: (params) => ({
        url: `${PRODUCT_URL}/jobboards`,
        params: { ...params, sort: 'name', sortDir: 'ASC' }
      }),
      transformResponse: (responseData) => {
        responseData.options = responseData?.jobBoards?.map((option) => (
          {
            label: option.name,
            value: option.id,
          }));
        return responseData || {};
      },
    }),
    updateProductInfo: builder.mutation({
      query: (data) => ({
        url: `${PRODUCT_URL}`,
        method: 'PUT',
        body: {
          ...data
        },
      }),
    }),
    jobboardIntegration: builder.mutation({
      query: (data) => ({
        url: `backoffice/multi-poster/company/job-boards`,
        method: 'POST',
        body: {
          ...data
        },
      }),
    }),
  }),

});

export const {
  useGetProductsAgainstJobboardQuery,
  useRemoveMultiposterJobboardMutation,
  useGetAllJobboardsAgainstCompanyQuery,
  useGetMultiposterJobBoardsMutation,
  useJobboardIntegrationMutation,
  useGetAllProductsQuery,
  useAddNewProductMutation,
  useRemoveProductMutation,
  useGetSingleProductByIdMutation,
  useUpdateProductInfoMutation,
  useGetJobBoardsMutation
} = extendedApiSlice;
